<template>
	<div class="m-channel-image">
		<p v-if="!unitData.list"></p>
		<a v-for="(item, i) in unitData.list" :key="i">
			<sub-image class="item" :src="item.img_url" mode="aspectFill"></sub-image>
		</a>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {},
				currentBanner: 0
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-image {
		min-height: 100px;
		
		.item {
			position: relative;
			left: 50%;
			min-width: 1920px;
			transform: translate(-50%,0);
		}
	}
</style>
